<template>
    <div>
        <Card>
            <div style="text-align:center">
                <img :src="imgSrc" style="height:300px;"/>
            </div>
        </Card>

    </div>
    
</template>
<script>
    export default {
        props:{
            imgSrc:{
                type: String,
            }
        },
        data() {
            return{
                myurl:'123'
            }
        },

        watch: {
            imgSrc(){
                
            }

        },
        methods: {
           
        }
    }
</script>

<style lang="less" scoped>
    .info-item {
        min-width: 250px;
        margin: 5px 20px;
        display: inline-block;
    }
</style>